import React from 'react';
import Icon from 'components/AppIcon';

const PhysicalDetailsSection = ({ formData, errors, isArabic, onInputChange }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center mb-6">
        <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
          <Icon name="Activity" size={20} color="#2563eb" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900">
          {isArabic ? 'التفاصيل الجسدية' : 'Physical Details'}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Height */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {isArabic ? 'الطول (سم)' : 'Height (cm)'}
            <span className="text-red-500 ml-1">*</span>
          </label>
          <div className="relative">
            <input
              type="number"
              value={formData.height}
              onChange={(e) => onInputChange('height', e.target.value)}
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200 ${
                errors.height ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder={isArabic ? 'أدخل الطول' : 'Enter height'}
              min="50"
              max="300"
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <span className="text-gray-500 text-sm">
                {isArabic ? 'سم' : 'cm'}
              </span>
            </div>
          </div>
          {errors.height && (
            <p className="mt-1 text-sm text-red-600 flex items-center">
              <Icon name="AlertCircle" size={16} className="mr-1" />
              {errors.height}
            </p>
          )}
        </div>

        {/* Weight */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {isArabic ? 'الوزن (كجم)' : 'Weight (kg)'}
            <span className="text-red-500 ml-1">*</span>
          </label>
          <div className="relative">
            <input
              type="number"
              value={formData.weight}
              onChange={(e) => onInputChange('weight', e.target.value)}
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200 ${
                errors.weight ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder={isArabic ? 'أدخل الوزن' : 'Enter weight'}
              min="20"
              max="500"
              step="0.1"
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <span className="text-gray-500 text-sm">
                {isArabic ? 'كجم' : 'kg'}
              </span>
            </div>
          </div>
          {errors.weight && (
            <p className="mt-1 text-sm text-red-600 flex items-center">
              <Icon name="AlertCircle" size={16} className="mr-1" />
              {errors.weight}
            </p>
          )}
        </div>
      </div>

      {/* BMI Calculation Display */}
      {formData.height && formData.weight && (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-700">
              {isArabic ? 'مؤشر كتلة الجسم (BMI):' : 'Body Mass Index (BMI):'}
            </span>
            <span className="text-lg font-semibold text-green-600">
              {((formData.weight / ((formData.height / 100) ** 2)).toFixed(1))}
            </span>
          </div>
          <div className="mt-2 text-xs text-gray-500">
            {isArabic 
              ? 'يتم حساب مؤشر كتلة الجسم تلقائياً بناءً على الطول والوزن' :'BMI is calculated automatically based on height and weight'
            }
          </div>
        </div>
      )}
    </div>
  );
};

export default PhysicalDetailsSection;